<template>
  <PageTemplate>
    <div class="element-box">
      <h6 class="element-header">
        {{ $t('ai_document_scan.title') }}
      </h6>
      <div class="element-content">
        <BaseDropzone v-model="files" :text="$t('ai_document_scan.label')"/>

        <div class="border-bottom py-3 text-center mb-5">
          <button
              :disabled="!files.length || isLoading"
              @click="documentScan"
              class="btn btn-primary"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              :title="!files.length ? 'keine Dateien' : ''">{{ $t('ai_document_scan.button_label') }}
            <span v-if="isLoading" class="spinner-border spinner-border-sm ms-1" role="status"
                  aria-hidden="true"></span>
          </button>
          <button
              v-if="files.length || documentData"
              :disabled="isLoading"
              @click="resetState"
              class="btn btn-reset ms-4">
            <i class="fa-solid fa-rotate-left me-1"></i> Zurücksetzen
          </button>
        </div>

        <h5 class="form-header text-center">{{ $t('ai_document_scan.analyzed_result') }}s</h5>
        <div v-if="documentData" class="row mt-4">
          <div class="col-8">

            <!-- CLIENT SECTION -->
            <div class="section-header">
              <h6 class="mb-0"><i class="os-icon os-icon-finance-29 section-icon"></i>Kostenträger</h6>
              <span class="badge" :class="matchBadge(numberOfClientFoundInSystem).class">
                {{ matchBadge(numberOfClientFoundInSystem).text }}
              </span>
            </div>


            <!--            {{ numberOfClientFoundInSystem }} {{ clientData$.$errors }}-->
            <div class="mt-3 ps-2">
              <p v-if="!numberOfClientFoundInSystem" class="text-danger fw-bolder mb-2">
                Der Kostenträger wurde nicht im System gefunden. Bitte legen Sie ihn zuerst an.
              </p>

              <SelectVue
                  classFormGroup="col-6 px-0"
                  v-if="numberOfClientFoundInSystem > 1"
                  v-model="clientData"
                  :options="documentData?.clientData.data"
                  :required="true"
                  label='Kostenträger'
                  placeholder="Wählen Sie Kostenträger"
                  :validation="clientData$?.id"
                  :messages="clientData$?.id?.required?.$message"/>

              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">Kundennummer:</span>
                <span>{{ clientData.customerNumber }}</span>
              </div>
              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">Abrechnungsstelle:</span>
                <span>{{ clientData.registrationOffice }}</span>
              </div>
              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">Kostenträger:</span>
                <span>{{ clientData?.name }}</span>
              </div>

              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">Ort:</span>
                <span>{{ clientData.city }}</span>
              </div>

              <div class="d-flex align-items-left mb-1">
                <span style="width: 150px; margin-right: 15px; font-weight: bold;">PLZ:</span>
                <span>{{ clientData.zip }}</span>
              </div>
            </div>


            <!-- UNEMPLOYED DATA -->
            <div class="section-header mt-5">
              <h6 class="mb-0"><i class="os-icon os-icon-search section-icon"></i>Kunde</h6>
              <span class="badge" :class="matchBadge(numberOfUnemployedFoundInSystem, true).class">
                {{ matchBadge(numberOfUnemployedFoundInSystem, true).text }}
              </span>
            </div>

            <!-- Unemployed not found in system (Create new one ) -->
            <div v-if="!documentData?.unemployedData?.foundInSystem" class="d-flex flex-wrap mt-3 ps-1">
              <BaseInput v-model="unemployedData.customerNumber"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="JC / AA Nummer:"/>

              <BaseInput v-model="unemployedData.firstName"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Vorname:"
                         :required=true
                         :validation="unemployedData$?.firstName"
                         :messages="unemployedData$?.firstName?.required?.$message"/>

              <BaseInput v-model="unemployedData.lastName"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Nachname:"
                         :required=true
                         :validation="unemployedData$?.lastName"
                         :messages="unemployedData$?.lastName?.required?.$message"/>

              <BaseInput v-model="unemployedData.aaNumber"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Straße:"
                         :required=true
                         :validation="unemployedData$?.aaNumber"
                         :messages="unemployedData$?.aaNumber?.required?.$message"/>

              <BaseInput v-model="unemployedData.address"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="PLZ:"
                         :required=true
                         :validation="unemployedData$?.address"
                         :messages="unemployedData$?.address?.required?.$message"/>

              <BaseInput v-model="unemployedData.city"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Ort:"
                         :required=true
                         :validation="unemployedData$?.city"
                         :messages="unemployedData$?.city?.required?.$message"/>

              <Datepicker v-model="unemployedData.birthDate"
                          classFormGroup="col-lg-4 col-md-6 col-sm-12"
                          :required="true"
                          label="Geburtsdatum"
                          :validation="unemployedData$?.birthDate"
                          :messages="unemployedData$?.birthDate?.required?.$message"/>

              <BaseInput v-model="unemployedData.placeOfBirth"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Geburtsort:"
                         :required=true
                         :validation="unemployedData$?.placeOfBirth"
                         :messages="unemployedData$?.placeOfBirth?.required?.$message"/>

              <SelectVue v-model="unemployedData.gender"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         :options="genders"
                         :is-clear="true"
                         :required="true"
                         :label="$t('general.gender')"
                         :validation="unemployedData$.gender"
                         :messages="unemployedData$.gender.required.$message"/>
            </div>

            <!-- Unemployed found in system -->
            <div v-else class="d-flex flex-wrap mt-3 ps-2">
              <SelectVue
                  v-if="numberOfUnemployedFoundInSystem > 1"
                  v-model="unemployedData"
                  :required="true"
                  classFormGroup="col-6 px-0"
                  :options="documentData?.unemployedData.data"
                  placeholder="Kunden auswählen"
                  label="Kunde"
                  :validation="unemployedData$?.id"
                  :messages="unemployedData$?.id?.required?.$message"/>
              <div class="col-lg-8 col-md-6 col-sm-12" v-if="unemployedData?.deleted">
                <p class="text-danger fw-bolder">Dieser Kunde ist gelöscht</p>
              </div>

              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Kundennummer:</h6>
                    <span>{{ unemployedData?.customerNumber }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Vorname:</h6>
                    <span>{{ unemployedData?.firstName }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Nachname:</h6>
                    <span>{{ unemployedData?.lastName }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">JC / AA Nummer:</h6>
                    <span>{{ unemployedData?.aaNumber }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Straße:</h6>
                    <span>{{ unemployedData?.address }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Ort:</h6>
                    <span>{{ unemployedData?.city }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-2 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Geburtsdatum:</h6>
                    <span>{{ unemployedData.birthDate }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Geburtsort:</h6>
                    <span>{{ unemployedData.placeOfBirth }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Geschlecht:</h6>
                    <span>{{ unemployedData.gender }}</span>
                  </div>
                </div>
              </div>
            </div>


            <!-- OFFICE SECTION -->
            <div class="section-header mt-5">
              <h6 class="mb-0"><i class="os-icon os-icon-home section-icon"></i>Standort</h6>
              <span class="badge" :class="matchBadge(numberOfOfficeFoundInSystem, true).class">
                {{ matchBadge(numberOfOfficeFoundInSystem, true).text }}
              </span>
            </div>

            <!-- Office not found in system (Create new one )-->
            <div v-if="!documentData?.officeData?.foundInSystem" class="d-flex flex-wrap mt-3 ps-2">
              <BaseInput v-model="officeData.name"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Bezeichnung:"
                         :required=true
                         :validation="officeData$?.name"
                         :messages="officeData$?.name?.required?.$message"/>

              <BaseInput v-model="officeData.address"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Straße:"
                         :required=true
                         :validation="officeData$?.address"
                         :messages="officeData$?.address?.required?.$message"/>

              <BaseInput v-model="officeData.zip"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="PLZ:"
                         :required=true
                         :validation="officeData$?.zip"
                         :messages="officeData$?.zip?.required?.$message"/>

              <BaseInput v-model="officeData.city"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Stadt:"
                         :required=true
                         :validation="officeData$?.city"
                         :messages="officeData$?.city?.required?.$message"/>

              <BaseInput v-model="officeData.phone"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Telefonnummer:"/>

              <BaseInput v-model="officeData.email"
                         type="email"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Email:"/>

              <SelectedDropdown classFormGroup="col-lg-4 col-md-6 col-sm-12"
                                v-model="officeData.engagementType"
                                :options="officeEngagementTypesDropdown"
                                :required="true"
                                :label="$t('general.office_engagement_type')"
                                :placeholder="$t('placeholder.engagement_type')"
                                :validation="officeData$?.engagementType"
                                :messages="officeData$?.engagementType?.required?.$message"/>

              <SelectedDropdown classFormGroup="col-lg-4 col-md-6 col-sm-12"
                                v-model="officeData.type"
                                :options="officeTypesDropdown"
                                :required="true"
                                :label="$t('general.type')"
                                :placeholder="$t('placeholder.type')"
                                :validation="officeData$?.type"
                                :messages="officeData$?.type?.required?.$message"/>

              <BaseInput v-model="officeData.costCenter"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="KS1:"
                         :required=true
                         :validation="officeData$?.costCenter"
                         :messages="officeData$?.costCenter?.required?.$message"/>

              <SelectedDropdown classFormGroup="col-lg-4 col-md-6 col-sm-12"
                                v-model="officeData.federalState"
                                @update:modelValue="updateFederalState"
                                :options="federalStatesDropdown"
                                :required="true"
                                :label="$t('general.federal_state')"
                                :placeholder="$t('placeholder.select_federal_state')"
                                :validation="officeData$?.federalState"
                                :messages="officeData$?.federalState?.required?.$message"/>

              <BaseInput v-model="officeData.regionTranslation"
                         classFormGroup="col-lg-4 col-md-6 col-sm-12"
                         label="Region"
                         :required=true
                         :validation="officeData$.region"
                         :messages="officeData$.region.required.$message"
                         readonly/>

              <BaseInput v-model="officeData.colorCode"
                         classFormGroup="col-lg-2 col-md-6 col-sm-12"
                         label="Standortfarbe:"
                         :required=true
                         type="color"
                         :validation="officeData$?.colorCode"
                         :messages="officeData$?.colorCode?.required?.$message"/>
            </div>

            <!-- Office found in system -->
            <div v-else class="d-flex flex-wrap mt-3 ps-2">
              <SelectVue
                  v-if="numberOfOfficeFoundInSystem > 1"
                  label="Standort"
                  v-model="officeData"
                  classFormGroup="col-6 px-0"
                  :options="documentData?.officeData.data"
                  placeholder="Wählen Sie Standort"
                  :required="true"
                  :validation="officeData$?.id"
                  :messages="officeData$?.id?.required?.$message"/>

              <div class="col-lg-8 col-md-6 col-sm-12" v-if="officeData?.deleted">
                <p class="text-danger fw-bolder">Dieser Standort wurde gelöscht</p>
              </div>

              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Bezeichnung:</h6>
                    <span>{{ officeData?.name }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Ort:</h6>
                    <span>{{ officeData?.city }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Straße:</h6>
                    <span>{{ officeData?.address }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Telefonnummer:</h6>
                    <span>{{ officeData?.phone }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">PLZ:</h6>
                    <span>{{ officeData?.zip }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Email:</h6>
                    <span>{{ officeData?.email }}</span>
                  </div>
                </div>
              </div>
              <div class="row mb-3 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Extern/Intern:</h6>
                    <span>{{ officeData.engagementType }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Typ:</h6>
                    <span>{{ officeData.type }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Standortfarbe:</h6>
                    <span :style="{
                              padding: '6px',
                              width: '50px',
                              height: '20px',
                              display: 'block',
                              background: officeData.colorCode,
                              borderRadius: '3px'}">
                      </span>
                  </div>
                </div>
              </div>
              <div class="row mb-2 w-100">
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Bundesland:</h6>
                    <span>{{ officeData.federalState }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">Region:</h6>
                    <span>{{ officeData.region }}</span>
                  </div>
                </div>
                <div class="col-4">
                  <div>
                    <h6 class="me-2 fw-bolder">KS1:</h6>
                    <span>{{ officeData.costCenter }}</span>
                  </div>
                </div>
              </div>
            </div>


            <!-- COURSE SECTION -->
            <div class="section-header mt-5">
              <h6 class="mb-0"><i class="os-icon os-icon-documents-03 section-icon"></i>Einzelcoachingmaßnahme</h6>
              <span class="badge" :class="matchBadge(numberOfCoachingCourseFoundInSystem).class">
                {{ matchBadge(numberOfCoachingCourseFoundInSystem).text }}
              </span>
            </div>

            <div class="mt-4 ps-2">
              <SelectVue
                  v-if="numberOfCoachingCourseFoundInSystem > 1"
                  v-model="coachingCourseData"
                  classFormGroup="col-6 px-0"
                  :required="true"
                  :options="documentData?.coachingCourseData.data"
                  label="Einzelcoachingmaßnahmen"
                  placeholder="Wählen Sie Einzelcoachingmaßnahmen"
                  :validation="coachingCourseData$?.id"
                  :messages="coachingCourseData$?.id?.required?.$message"/>

              <div class="d-flex align-items-left">
                <h6 class="fw-bolder me-1">Bezeichnung:</h6>
                <span>{{ coachingCourseData.nameOfCoaching }}</span>
              </div>
              <div class="d-flex align-items-left">
                <h6 class="fw-bolder me-1">Maßnahmenart:</h6>
                <span>{{ coachingCourseData.operationType }}</span>
              </div>
              <div class="d-flex align-items-left">
                <h6 class="fw-bolder me-1">Maßnahmennummer:</h6>
                <span>{{ coachingCourseData.actionNumber }}</span>
              </div>
              <div class="d-flex align-items-left">
                <h6 class="fw-bolder me-1">Dauer der Maßnahme (in Wochen):</h6>
                <span>{{ coachingCourseData.duration }}</span>
              </div>
              <div class="d-flex align-items-left">
                <h6 class="fw-bolder me-1">Einheiten (Gesamtanzahl):</h6>
                <span>{{ coachingCourseData.units }}</span>
              </div>
            </div>

            <div class="section-header mt-5">
              <h6 class="mb-0"><i class="os-icon os-icon-list section-icon"></i>Neues Einzelcoaching</h6>
            </div>

            <div class="row gx-3 mt-4 ps-2">
              <Datepicker
                  label="Start"
                  classFormGroup="col-lg-3 col-md-6 col-sm-12"
                  v-model="coachingData.coachingStartDate"
                  :required="true"
                  :validation="coachingData$.coachingStartDate"
                  :messages="coachingData$.coachingStartDate.required.$message"/>
              <Datepicker
                  label="Ende"
                  classFormGroup="col-lg-3 col-md-6 col-sm-12"
                  v-model="coachingData.coachingEndDate"
                  :required="true"
                  :validation="coachingData$.coachingEndDate"
                  :messages="coachingData$.coachingEndDate.required.$message"/>
              <Datepicker
                  label="AVGS Gültigkeit -Start"
                  classFormGroup="col-lg-3 col-md-6 col-sm-12"
                  v-model="coachingData.coachingMaxDateOfFirstMeeting"
                  :required="true"
                  :validation="coachingData$.coachingMaxDateOfFirstMeeting"
                  :messages="coachingData$.coachingMaxDateOfFirstMeeting.required.$message"/>
              <Datepicker
                  label="AVGS Gültigkeit -Ende"
                  classFormGroup="col-lg-3 col-md-6 col-sm-12"
                  v-model="coachingData.coachingMinDateOfFirstMeeting"
                  :required="true"
                  :validation="coachingData$.coachingMinDateOfFirstMeeting"
                  :messages="coachingData$.coachingMinDateOfFirstMeeting.required.$message"/>
            </div>

            <!--            {{ clientData$.$errors }} {{ unemployedData$.$errors }} {{ officeData$.$errors }}-->
            <!--            {{ coachingCourseData$.$errors }}-->

            <ValidationErrorMessage
                :validationErrors="[
                  ...clientData$.$errors,
                  ...unemployedData$.$errors,
                  ...officeData$.$errors,
                  ...coachingCourseData$.$errors,
                  ...coachingData$.$errors,
                ]">
            </ValidationErrorMessage>

            <div class="d-flex justify-content-center mt-4 pt-3 border-top">
              <div class="btn btn-primary" @click="submitDocument">
                {{ t('general.button.save') }}
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="document-preview-container card p-2">
              <div class="d-flex align-items-center mb-2">
                <input type="range" min="1.5" max="5" step="0.5" v-model.number="zoom" class="form-range me-2"/>
                <span class="text-nowrap">Lupe: {{ zoom }}x</span>
              </div>
              <div v-for="(file, index) in files" :key="file.name">
                <div class="mb-1" :class="{ 'mt-4': index > 0 }">{{ file.name }}</div>
                <DocumentMagnifierPreview :file="file" :zoom="zoom"/>
              </div>


              <!--              <div>-->
              <!--                <h6 class="text-center mt-2">{{ files[ 0 ].name }}</h6>-->
              <!--                <input type="range" min="50" max="150" v-model="zoom"/> Zoom: {{ zoom }}%-->
              <!--                <div>-->
              <!--                  <iframe-->
              <!--                      v-if="pdfUrls[0]"-->
              <!--                      height="600"-->
              <!--                      width="100%"-->
              <!--                      :src="computedPdfUrl"></iframe>-->
              <!--                </div>-->
              <!--&lt;!&ndash;                <div class="controls mt-2 mb-2 d-flex justify-content-center" style="gap: 30px;">&ndash;&gt;-->
              <!--&lt;!&ndash;                  <button class="btn btn-sm btn-primary">Vorherige</button>&ndash;&gt;-->
              <!--&lt;!&ndash;                  <span>Seite: <span>1</span> /<span>{{ pdfUrls.length }}</span></span>&ndash;&gt;-->
              <!--&lt;!&ndash;                  <button class="btn btn-sm btn-primary">Nächste</button>&ndash;&gt;-->
              <!--&lt;!&ndash;                </div>&ndash;&gt;-->

              <!--              </div>-->
            </div>
          </div>
        </div>
        <h6 v-else class="text-center">
          {{ $t('ai_document_scan.no_data_available_text') }}
        </h6>

      </div>
    </div>
  </PageTemplate>
</template>
<script setup>
import aiDocumentScanService from '@/api/AiDocumentScan';
import BaseDropzone from '@/components/base/BaseDropzone.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import DocumentMagnifierPreview from '@/views/App/AiDocumentScan/components/DocumentMagnifierPreview.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Datepicker from '@/components/picker/Datepicker.vue';
import SelectedDropdown from '@/components/SelectDropdown.vue';
import SelectVue from '@/components/SelectVue.vue';
import ValidationErrorMessage from '@/components/ValidationErrorMessage.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { requiredRule } from '@/shared/validators/validationRules';
import { piniaEnumsStore } from '@/store/piniaEnumsStore';
import useVuelidate from '@vuelidate/core';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }           = useI18n();
const piniaEnumsState = piniaEnumsStore();
const { genders }     = computed(() => piniaEnumsState.enums).value;
const getEnums        = computed(() => piniaEnumsState.enums);

const isSubmitting                        = ref(false);
const files                               = ref([]);
const federalStatesDropdown               = ref([]);
const officeEngagementTypesDropdown       = ref([]);
const officeTypesDropdown                 = ref([]);
const regionsDropdown                     = ref([]);
const documentData                        = ref();
const clientData                          = ref({});
const numberOfClientFoundInSystem         = ref(0);
const unemployedData                      = ref({});
const numberOfUnemployedFoundInSystem     = ref(0);
const officeData                          = ref({});
const numberOfOfficeFoundInSystem         = ref(0);
const coachingCourseData                  = ref({});
const numberOfCoachingCourseFoundInSystem = ref(0);
const coachingData                        = ref({
  coachingStartDate: null,
  coachingEndDate: null,
  coachingMinDateOfFirstMeeting: null,
  coachingMaxDateOfFirstMeeting: null,
});

watchEffect(() => {
  coachingData.value.clientId                      = clientData.value?.id || null;
  coachingData.value.coachingStartDate             = coachingData.value.coachingStartDate || documentData.value?.finalData.StartDate || null;
  coachingData.value.coachingEndDate               = coachingData.value.coachingEndDate || documentData.value?.finalData.StartDate || null;
  coachingData.value.coachingMinDateOfFirstMeeting = coachingData.value.coachingMinDateOfFirstMeeting || documentData.value?.finalData.coachingMaxDateOfFirstMeeting || null;
  coachingData.value.coachingMaxDateOfFirstMeeting = coachingData.value.coachingMaxDateOfFirstMeeting || documentData.value?.finalData.coachingMinDateOfFirstMeeting || null;
});

const rulesOfficeData = {
  name: requiredRule(t),
  address: requiredRule(t),
  zip: requiredRule(t),
  city: requiredRule(t),
  engagementType: requiredRule(t),
  type: requiredRule(t),
  colorCode: requiredRule(t),
  federalState: requiredRule(t),
  costCenter: requiredRule(t),
  region: requiredRule(t),
};

const rulesUnemployedData = {
  firstName: requiredRule(t),
  lastName: requiredRule(t),
  aaNumber: requiredRule(t),
  address: requiredRule(t),
  city: requiredRule(t),
  birthDate: requiredRule(t),
  placeOfBirth: requiredRule(t),
  gender: requiredRule(t),
};

const rulesCoachingData = {
  clientId: requiredRule(t),
  coachingStartDate: requiredRule(t),
  coachingEndDate: requiredRule(t),
  coachingMinDateOfFirstMeeting: requiredRule(t),
  coachingMaxDateOfFirstMeeting: requiredRule(t),
};

// Records found in the system are shown read-only, so only the selection is validated when there are multiple matches
const selectionRules = (count) => count > 1 ? { id: requiredRule(t) } : {};

const computedClientRules         = computed(() => selectionRules(numberOfClientFoundInSystem.value));
const computedUnemployedRules     = computed(() => documentData.value?.unemployedData?.foundInSystem
    ? selectionRules(numberOfUnemployedFoundInSystem.value)
    : rulesUnemployedData);
const computedOfficeRules         = computed(() => documentData.value?.officeData?.foundInSystem
    ? selectionRules(numberOfOfficeFoundInSystem.value)
    : rulesOfficeData);
const computedCoachingCourseRules = computed(() => selectionRules(numberOfCoachingCourseFoundInSystem.value));
const computedRulesCoachingData   = computed(() => rulesCoachingData);

const clientData$         = useVuelidate(computedClientRules, clientData);
const unemployedData$     = useVuelidate(computedUnemployedRules, unemployedData);
const officeData$         = useVuelidate(computedOfficeRules, officeData);
const coachingCourseData$ = useVuelidate(computedCoachingCourseRules, coachingCourseData);
const coachingData$       = useVuelidate(computedRulesCoachingData, coachingData);

const isLoading = ref(false);
const pdfUrls   = ref([]);
const zoom      = ref(2.5);

const matchBadge = (count, canCreateNew = false) => {
  if (count === 1) {
    return { class: 'bg-success', text: 'Im System gefunden' };
  }
  if (count > 1) {
    return { class: 'bg-warning text-dark', text: `${count} Treffer – bitte auswählen` };
  }
  return canCreateNew
      ? { class: 'bg-info text-dark', text: 'Nicht gefunden – wird neu angelegt' }
      : { class: 'bg-danger', text: 'Nicht im System gefunden' };
};

const documentScan = async () => {

  const formData = new FormData();

  isLoading.value = true;

  if (files.value?.length) {
    for (const item of files.value) {
      formData.append('documents[]', item);
      pdfUrls.value.push(URL.createObjectURL(item));
    }
  }

  try {
    const { data } = await aiDocumentScanService.aiDocumentScan(formData);

    documentData.value = data.data;

    // Client
    const clientScanData              = data.data?.clientData;
    numberOfClientFoundInSystem.value = clientScanData.count;

    if (numberOfClientFoundInSystem.value === 1) {
      clientData.value = clientScanData.data[ 0 ].value;
    }

    // Unemployed
    const unemployedScanData = data.data?.unemployedData;
    const countUnemployed    = unemployedScanData.count;

    numberOfUnemployedFoundInSystem.value = unemployedScanData.foundInSystem ? countUnemployed : 0;
    if (countUnemployed === 1) {
      unemployedData.value = unemployedScanData.data[ 0 ].value;
    }

    // Office
    const officeScanData = data.data?.officeData;
    const countOffice    = officeScanData.count;

    numberOfOfficeFoundInSystem.value = officeScanData.foundInSystem ? countOffice : 0;
    if (countOffice === 1) {
      officeData.value = officeScanData.data[ 0 ].value;
    }

    // Coaching course
    const coachingCourseScanData = data.data?.coachingCourseData;
    const countCoachingCourse    = coachingCourseScanData.count;

    numberOfCoachingCourseFoundInSystem.value = countCoachingCourse;
    if (countCoachingCourse === 1) {
      coachingCourseData.value = coachingCourseScanData.data[ 0 ].value;
    }

  } catch (error) {
    await ErrorToast(error);
  } finally {
    isLoading.value = false;
  }
};

const submitDocument = async () => {
  CloseToast();

  // Touch every section so all empty required fields are highlighted at once
  const validators = [ clientData$, unemployedData$, officeData$, coachingCourseData$, coachingData$ ];
  validators.forEach(validator => validator.value.$touch());

  if (validators.some(validator => validator.value.$invalid)) {
    return;
  }

  const submittedData = {
    clientData: clientData.value,
    officeData: officeData.value,
    unemployedData: unemployedData.value,
    coachingCourseData: coachingCourseData.value,
    coachingData: coachingData.value,
  };

  try {
    await aiDocumentScanService.createPrivateCoachingFromDocumentScan(submittedData);

    await router.push({ name: 'clientList' });

    isSubmitting.value = false;
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }

};

const resetState = () => {
  CloseToast();

  files.value                               = [];
  pdfUrls.value.forEach(url => URL.revokeObjectURL(url));
  pdfUrls.value                             = [];
  documentData.value                        = undefined;
  clientData.value                          = {};
  unemployedData.value                      = {};
  officeData.value                          = {};
  coachingCourseData.value                  = {};
  numberOfClientFoundInSystem.value         = 0;
  numberOfUnemployedFoundInSystem.value     = 0;
  numberOfOfficeFoundInSystem.value         = 0;
  numberOfCoachingCourseFoundInSystem.value = 0;
  coachingData.value                        = {
    coachingStartDate: null,
    coachingEndDate: null,
    coachingMinDateOfFirstMeeting: null,
    coachingMaxDateOfFirstMeeting: null,
  };

  [ clientData$, unemployedData$, officeData$, coachingCourseData$, coachingData$ ].forEach(validator => validator.value.$reset());
};

const updateFederalState = (newValue) => {
  const regionFromFederalState = regionsDropdown.value.find(regionDropdown => regionDropdown.federal_state_key === newValue);

  if (regionFromFederalState) {
    officeData.value.region            = regionFromFederalState.key;
    officeData.value.regionTranslation = regionFromFederalState.value;
  } else {
    officeData.value.region            = '';
    officeData.value.regionTranslation = '';
  }
};

onMounted(async () => {
  federalStatesDropdown.value         = getEnums.value?.federalStates || [];
  officeTypesDropdown.value           = getEnums.value?.officeTypes || [];
  officeEngagementTypesDropdown.value = getEnums.value?.officeEngagementTypes || [];
  regionsDropdown.value               = getEnums.value?.regions || [];
});


</script>
<style scoped>
.btn-reset {
  color: #c0392b;
  background-color: #fdecea;
  border: 1px solid #f5c2c0;
}

.btn-reset:hover:not(:disabled) {
  color: #fff;
  background-color: #e57373;
  border-color: #e57373;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border: 1px solid #dee2e6;
  border-left: 4px solid var(--primary);
  border-radius: 4px;
  background-color: #f8f9fa;
}

.section-header h6 {
  display: flex;
  align-items: center;
}

.section-icon {
  margin-right: 8px;
  font-size: 1.1rem;
  color: var(--primary);
}

.section-header .badge {
  font-size: 0.75rem;
  font-weight: 500;
}
</style>